/**
 * Fallback method to copy text to clipboard for browsers that don't support the Clipboard API
 * @param text - The text to copy to clipboard
 */
function fallbackCopyTextToClipboard(text: string): void {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    
    document.body.removeChild(textArea);
  }
  
  /**
   * Copy text to clipboard using Clipboard API with fallback for unsupported browsers
   * @param text - The text to copy to clipboard
   */
  export function copyTextToClipboard(text: string): void {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Async: Copying to clipboard was successful!');
      })
      .catch((err) => {
        console.error('Async: Could not copy text: ', err);
      });
  }


/**
  * Adds a parameter and value to the current URL's query string
  * @param paramName - The name of the parameter to add
  * @param paramValue - The value of the parameter to add
  * @returns The new URL with the added parameter
  */
 export function addParamToCurrentUrl(paramName: string, paramValue: string): string {
   // Get the current URL
   const currentUrl = window.location.href;
   
   // Create a URL object for easier manipulation
   const url = new URL(currentUrl);
   
   // Set the parameter (this will automatically handle whether it already exists)
   url.searchParams.set(paramName, paramValue);
   
   // Return the new URL as a string
   return url.toString();
 }